import { ApprovedApplication } from './components/ApprovedApplication/ApprovedApplication';
import { CancelledView } from './components/CancelledView/CancelledView';
import { DeclinedApplication } from './components/DeclinedApplication/DeclinedApplication';
import { EndedPaymentPlanView } from './components/EndedPaymentPlanView/EndedPaymentPlanView';
import { ExpiredApplication } from './components/ExpiredApplication/ExpiredApplication';
import { NothingSelectedView } from './components/NothingSelectedView/NothingSelectedView';
import { OngoingLoanView } from './components/OngoingLoanView/OngoingLoanView';
import { OverdueView } from './components/OverdueView/OverdueView';
import { PartialView } from './components/PartialView/PartialView';
import { PendingApplication } from './components/PendingApplication/PendingApplication';
import { ScheduledView } from './components/ScheduledView/ScheduledView';
import { Plan } from './Dashboard.types';

export function renderSelectedComponent(selectedPlan: Plan | null) {
  if (!selectedPlan) return <NothingSelectedView />;

  switch (selectedPlan.status) {
    case 'overdue':
      return <OverdueView paymentPlan={selectedPlan} />;
    case 'ongoing':
      return <OngoingLoanView paymentPlan={selectedPlan} />;
    case 'pending':
      return <PendingApplication />;
    case 'partial':
      return <PartialView application={selectedPlan} />;
    case 'approved':
      return <ApprovedApplication application={selectedPlan} />;
    case 'expired':
      return <ExpiredApplication />;
    case 'declined':
      return <DeclinedApplication application={selectedPlan} />;
    case 'ended':
      return <EndedPaymentPlanView />;
    case 'scheduled':
      return <ScheduledView plan={selectedPlan} />;
    case 'cancelled':
      return <CancelledView plan={selectedPlan} />;
    default:
      return null;
  }
}
